import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Controller, useForm } from "react-hook-form";

import { validatingMaxBrazilianPhoneLength, waitTimeout } from "../../../utils";

import Phone from "../../../components/welcome/phone";
import Recaptcha from "../../../components/Recaptcha";
import { Button } from "../../../shared/components";

import { Error, Label } from "../../../shared/components/Input/styles";
import { Col, Container, Content, FormGroupInput, FormSubmit, Subtitle, Title } from "../styles";

import {
	changeLoading,
	updateOnboardFieldRequest,
	validateInitialOnboardingPhone,
} from "../../../store/modules/register/actions";

const ConfirmationPhone = () => {
	const dispatch = useDispatch();

	const { loading, initialOnboardingResponseData } = useSelector((state) => state.register);
	const {
		control,
		formState: { errors },
		clearErrors,
		setValue,
		setError,
		watch,
		getValues,
	} = useForm();

	const [editable, setEditable] = useState(false);
	const [isValidCaptcha, setIsValidCaptcha] = useState(false);
	const [tokenRecaptcha, setTokenRecaptcha] = useState(null);
	const [formStatus, setFormStatus] = useState({
		error: false,
		isEmpty: true,
	});

	const cellular = getValues("cellular");

	useEffect(() => {
		const inputCellular = document.getElementsByTagName("input")[0];

		if (inputCellular) {
			inputCellular.focus();
		}

		const { unsubscribe } = watch((value, { name }) => {
			const hasErrorMessage = validatingMaxBrazilianPhoneLength(value[name]);
			const hasDigits = value[name].length > 5;

			if (hasDigits && hasErrorMessage.length) {
				setError(name, { message: hasErrorMessage });
			} else {
				clearErrors(name);
			}

			setFormStatus({
				error: Boolean(hasErrorMessage.length),
				isEmpty: !hasDigits,
			});
		});
		return () => unsubscribe();
	}, []);

	const sendCode = async () => {
		dispatch(changeLoading(true));
		updateField();

		await waitTimeout(1000);

		dispatch(
			validateInitialOnboardingPhone({
				cd_access_token: initialOnboardingResponseData.cd_access_token,
				value: cellular,
				type: "whatsapp",
				header: tokenRecaptcha,
			})
		);
	};

	const updateField = () => {
		if (cellular && !validatingMaxBrazilianPhoneLength(cellular).length) {
			dispatch(updateOnboardFieldRequest("phone_number", cellular, null, editable));
		}
	};

	return (
		<Container>
			<Content>
				<Col>
					<Title>Criar uma conta</Title>
					<Subtitle>
						Para sua própria segurança, confirme seu{" "}
						<span style={{ color: "var(--brand-primary)" }}>
							{" "}
							número de celular
						</span>{" "}
						para receber um código de verificação.
					</Subtitle>
				</Col>
				<FormGroupInput>
					<Controller
						name="cellular"
						control={control}
						render={({ field: { value }, formState: { errors } }) => (
							<>
								<Label>DDD + Número de celular</Label>
								<Phone
									id="cellular_number"
									numberPhone={value}
									onChange={(param) => {
										setValue(
											"cellular",
											String(
												param
											).replace(
												/\D/g,
												""
											)
										);

										if (
											param.length <=
											2
										) {
											setFormStatus(
												{
													error: false,
													isEmpty: true,
												}
											);
										}
									}}
									onFocus={({
										currentTarget,
									}) => {
										if (
											!currentTarget
												.value
												.length
										)
											return;

										setEditable(
											currentTarget
												.value
												.length >
												5 &&
												!validatingMaxBrazilianPhoneLength(
													currentTarget.value
												)
													.length
										);
									}}
									error={
										Object.keys(errors)
											.length
									}
								/>
								{Object.keys(errors).length ? (
									<Error>
										{
											errors
												.cellular
												.message
										}
									</Error>
								) : null}
							</>
						)}
					/>
				</FormGroupInput>

				<Recaptcha
					isValid={(param) => setIsValidCaptcha(param)}
					token={setTokenRecaptcha}
				/>

				<FormSubmit>
					<Button
						title="Enviar código"
						disabled={
							Object.keys(errors).length ||
							formStatus.error ||
							formStatus.isEmpty ||
							!isValidCaptcha
						}
						onClick={() => sendCode()}
						loading={loading}
					></Button>
				</FormSubmit>
			</Content>
		</Container>
	);
};

export default ConfirmationPhone;
